module.exports = __webpack_public_path__ + "static/img/income2.9394712.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/income2.png
// module id = B39f
// module chunks = 2